import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box } from 'Components/Base';
import CreateEditForm from 'Containers/CreateEditForm';

import { getSubscription } from '../../GraphQL/query/Products.query';
import { updateSubscriptionCategoriesMutation } from '../../GraphQL/mutation/Products.mutation';
import SKUCategoriesForm from '../SKUCategoriesForm';
import { SKU_CATEGORY } from '../../Domains/constants';

class SubscriptionCategoriesEditor extends Component {
  render() {
    const { subscription = {} } = this.props;
    const { id, SKUCode } = subscription;
    return (
      <Box>
        <CreateEditForm
          dataQuery={getSubscription}
          editMutation={updateSubscriptionCategoriesMutation}
          isEdit={true}
          id={SKUCode}
          idVariable={'SKUCode'}
          getQueryVariables={() => ({
            SKUCode,
          })}
          getEditVariables={(form) => ({
            id,
            data: {
              ...form,
            },
          })}
        >
          {({ data, onSubmit }) => {
            return (
              <SKUCategoriesForm
                skuCategory={SKU_CATEGORY.SUBSCRIPTION}
                initialData={data && data.sfBoProductSubscription}
                onSubmit={onSubmit}
              />
            );
          }}
        </CreateEditForm>
      </Box>
    );
  }
}

export default SubscriptionCategoriesEditor;
